<div class="fm-authentication">
  <div class="container-fluid fm-container-full">
    <div class="row h-100">

      <!-- Cover Image -->
      <div class="col-lg-6 p-0 position-relative d-none d-lg-block">
        <div class="fm-cover-image">
          <img src="images/signin/fm-signin-bg.png" alt="signin Cover" class="img-fluid" id="fmsigninImage" />
        </div>
      </div>

      <!-- Auth Card -->
      <div class="col-lg-6">
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col-sm-11">
            <div class="fm-auth-card">

              <!-- Form Head Section -->
              <div class="fm-auth-chead">
                <div class="fm-logo">
                  <a routerLink="/"><img src="images/logo.svg" width="213" alt="Forever Memories" /></a>
                </div>
                <h3 class="fm-head-28 fm-head-sty2 fw-title fw-bold">Start preserving your life stories</h3>
                <p>Sign up to start capturing, organizing, and preserving your memories effortlessly.</p>
              </div>

              <!-- Form Tabs Section -->
              <div class="fm-tabs-section">
                <div class="fm-auto-tabs nav">
                  <button type="button" class="fm-auth-tab-btn"
                    [class.active]="activeTab() === 'signup'"
                    (click)="setTab('signup')">Sign Up</button>
                  <button type="button" class="fm-auth-tab-btn"
                    [class.active]="activeTab() === 'signin'"
                    (click)="setTab('signin')">Sign In</button>
                </div>

                <div class="tab-content fm-auto-content">

                  <!-- Sign Up Form -->
                  <div class="tab-pane fade" [class.show]="activeTab() === 'signup'" [class.active]="activeTab() === 'signup'">
                    <div class="fm-signin-form">
                      <form [formGroup]="registerForm" (ngSubmit)="onSignUp()" novalidate>
                        <fieldset class="row g-3 g-sm-4">
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label class="fm-label">First Name</label>
                              <input type="text" placeholder="Enter Your First Name"
                                class="form-control"
                                [class.is-invalid]="rf['firstName'].invalid && rf['firstName'].touched"
                                formControlName="firstName" autocomplete="given-name" />
                              @if (rf['firstName'].invalid && rf['firstName'].touched) {
                                <div class="invalid-feedback">First name is required.</div>
                              }
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label class="fm-label">Last Name</label>
                              <input type="text" placeholder="Enter Your Last Name"
                                class="form-control"
                                [class.is-invalid]="rf['lastName'].invalid && rf['lastName'].touched"
                                formControlName="lastName" autocomplete="family-name" />
                              @if (rf['lastName'].invalid && rf['lastName'].touched) {
                                <div class="invalid-feedback">Last name is required.</div>
                              }
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <label class="fm-label">Email Address</label>
                              <input type="email" placeholder="Enter Your Email Address"
                                class="form-control"
                                [class.is-invalid]="rf['email'].invalid && rf['email'].touched"
                                formControlName="email" autocomplete="email" />
                              @if (rf['email'].errors?.['required'] && rf['email'].touched) {
                                <div class="invalid-feedback">Email is required.</div>
                              }
                              @if (rf['email'].errors?.['email'] && rf['email'].touched) {
                                <div class="invalid-feedback">Please enter a valid email.</div>
                              }
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <label class="fm-label">Password</label>
                              <div class="fm-input-group">
                                <input [type]="showRegisterPassword() ? 'text' : 'password'"
                                  placeholder="Enter Your Password"
                                  class="form-control"
                                  [class.is-invalid]="rf['password'].invalid && rf['password'].touched"
                                  formControlName="password" autocomplete="new-password" />
                                <button type="button" class="fm-toggle-password" (click)="toggleRegisterPassword()" aria-label="Toggle password visibility">
                                  @if (showRegisterPassword()) {
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                  } @else {
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                                  }
                                </button>
                              </div>
                              @if (rf['password'].errors?.['required'] && rf['password'].touched) {
                                <div class="invalid-feedback d-block">Password is required.</div>
                              }
                              <!-- Password strength hints -->
                              @if (rf['password'].dirty || rf['password'].touched) {
                                <div class="fm-pw-hints">
                                  <div class="fm-pw-hint" [class.met]="passwordCriteria.minLength">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                    At least 8 characters
                                  </div>
                                  <div class="fm-pw-hint" [class.met]="passwordCriteria.maxLength">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                    Max 12 characters
                                  </div>
                                  <div class="fm-pw-hint" [class.met]="passwordCriteria.hasUpper">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                    1 uppercase letter
                                  </div>
                                  <div class="fm-pw-hint" [class.met]="passwordCriteria.hasNumber">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                    1 number
                                  </div>
                                  <div class="fm-pw-hint" [class.met]="passwordCriteria.hasSpecial">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                    1 special character (@$!%*?&)
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                          <!-- Confirm Password (commented out)
                          <div class="col-12">
                            <div class="form-group">
                              <label class="fm-label">Confirm Password</label>
                              <div class="fm-input-group">
                                <input [type]="showConfirmPassword() ? 'text' : 'password'"
                                  placeholder="Re-Enter Password"
                                  class="form-control"
                                  [class.is-invalid]="(rf['confirmPassword'].invalid && rf['confirmPassword'].touched) || !!passwordMismatch"
                                  formControlName="confirmPassword" autocomplete="new-password" />
                                <button type="button" class="fm-toggle-password" (click)="toggleConfirmPassword()" aria-label="Toggle password visibility">
                                  @if (showConfirmPassword()) {
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                  } @else {
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                                  }
                                </button>
                              </div>
                              @if (passwordMismatch) {
                                <div class="invalid-feedback d-block">Passwords do not match.</div>
                              }
                            </div>
                          </div>
                          -->
                          <div class="col-12">
                            <button class="fm-common-btn w-100 mt-2 mt-lg-3" type="submit" [disabled]="isRegisterLoading()">
                              @if (isRegisterLoading()) {
                                <span class="spinner-border spinner-border-sm me-2" role="status"></span>Creating account...
                              } @else {
                                Create Account
                              }
                            </button>
                          </div>
                        </fieldset>
                      </form>
                    </div>
                  </div>

                  <!-- Sign In Form -->
                  <div class="tab-pane fade" [class.show]="activeTab() === 'signin'" [class.active]="activeTab() === 'signin'">
                    <div class="fm-signin-form">
                      <form [formGroup]="loginForm" (ngSubmit)="onSignIn()" novalidate>
                        <fieldset class="row g-3 g-sm-4">
                          <div class="col-12">
                            <div class="form-group">
                              <label class="fm-label">Email Address</label>
                              <input type="email" placeholder="Enter Your Email Address"
                                class="form-control"
                                [class.is-invalid]="lf['email'].invalid && lf['email'].touched"
                                formControlName="email" autocomplete="email" />
                              @if (lf['email'].errors?.['required'] && lf['email'].touched) {
                                <div class="invalid-feedback">Email is required.</div>
                              }
                              @if (lf['email'].errors?.['email'] && lf['email'].touched) {
                                <div class="invalid-feedback">Please enter a valid email.</div>
                              }
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <label class="fm-label">Password</label>
                              <div class="fm-input-group">
                                <input [type]="showLoginPassword() ? 'text' : 'password'"
                                  placeholder="Enter Your Password"
                                  class="form-control"
                                  [class.is-invalid]="lf['password'].invalid && lf['password'].touched"
                                  formControlName="password" autocomplete="current-password" />
                                <button type="button" class="fm-toggle-password" (click)="toggleLoginPassword()" aria-label="Toggle password visibility">
                                  @if (showLoginPassword()) {
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                  } @else {
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                                  }
                                </button>
                              </div>
                              @if (lf['password'].invalid && lf['password'].touched) {
                                <div class="invalid-feedback d-block">Password is required.</div>
                              }
                            </div>
                          </div>
                          <div class="col-12 mt-4">
                            <div class="row g-3 align-items-center">
                              <div class="col">
                                <div class="form-check fm-check-large">
                                  <input class="form-check-input" type="checkbox" formControlName="rememberMe" id="fmRememberMe" />
                                  <label class="form-check-label" for="fmRememberMe">Remember Me</label>
                                </div>
                              </div>
                              <div class="col-auto">
                                <a routerLink="/forgot-password" class="fm-basic-link">Forgot Password?</a>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <button class="fm-common-btn w-100 mt-lg-2" type="submit" [disabled]="isLoginLoading()">
                              @if (isLoginLoading()) {
                                <span class="spinner-border spinner-border-sm me-2" role="status"></span>Signing in...
                              } @else {
                                Sign In
                              }
                            </button>
                          </div>
                          @if (showVerificationBanner()) {
                            <div class="col-12">
                              <div class="fm-verify-banner">
                                <div class="fm-verify-banner-icon">
                                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                    <polyline points="22,6 12,13 2,6"></polyline>
                                  </svg>
                                </div>
                                <div class="fm-verify-banner-body">
                                  <p class="fm-verify-banner-title">Email not verified</p>
                                  <p class="fm-verify-banner-text">Please verify your email to continue. Didn't get the email?</p>
                                  <button type="button" class="fm-resend-link" (click)="onResendVerificationFromLogin()" [disabled]="isResendLoading()">
                                    @if (isResendLoading()) {
                                      <span class="spinner-border spinner-border-sm me-1" role="status"></span>Sending...
                                    } @else {
                                      Resend verification email
                                    }
                                  </button>
                                </div>
                              </div>
                            </div>
                          }
                        </fieldset>
                      </form>
                    </div>
                  </div>

                </div>
              </div>

              <!-- Form Bottom Section with Social Icons -->
              <div class="fm-sign-bottom">
                <div class="fm-middle-line">
                  <p class="fm-black-cl">Continue with</p>
                </div>
                <div class="fm-social-icons">
                  <ul class="fm-social-icons-ul">
                    <li class="fm-social-icons-li">
                      <button type="button" class="fm-social-btn" (click)="onAppleLogin()" [disabled]="isAppleLoading()" aria-label="Sign in with Apple">
                        @if (isAppleLoading()) {
                          <span class="spinner-border spinner-border-sm" role="status"></span>
                        } @else {
                          <span class="fm-si-column"><img class="fm-si" src="images/social-icons/apple.svg" alt="Apple" /></span>
                        }
                      </button>
                    </li>
                    <li class="fm-social-icons-li">
                      <button type="button" class="fm-social-btn" (click)="onGoogleLogin()" [disabled]="isGoogleLoading()" aria-label="Sign in with Google">
                        @if (isGoogleLoading()) {
                          <span class="spinner-border spinner-border-sm" role="status"></span>
                        } @else {
                          <span class="fm-si-column"><img class="fm-si" src="images/social-icons/google.svg" alt="Google" /></span>
                        }
                      </button>
                    </li>
                    <li class="fm-social-icons-li">
                      <button type="button" class="fm-social-btn" (click)="onFacebookLogin()" [disabled]="isFacebookLoading()" aria-label="Sign in with Facebook">
                        @if (isFacebookLoading()) {
                          <span class="spinner-border spinner-border-sm" role="status"></span>
                        } @else {
                          <span class="fm-si-column"><img class="fm-si" src="images/social-icons/fb.svg" alt="Facebook" /></span>
                        }
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
